import { IVehicleWheelsSettings, VehicleWheelsSetting } from '~/shared';

export const isDefaultValues = (
	wheelSettings: IVehicleWheelsSettings,
	defaultValues: IVehicleWheelsSettings,
) => {
	return Object.entries(defaultValues).every(
		([key, value]) => wheelSettings[key as VehicleWheelsSetting] === value,
	);
};

export const getWheelSettingsTotalPrice = (
	wheelSettings: IVehicleWheelsSettings,
	wheelSetupPrice: number,
	defaultValues: IVehicleWheelsSettings,
) => {
	let price = 0;

	if (!isDefaultValues(wheelSettings, defaultValues)) {
		for (const key in wheelSettings) {
			const value = wheelSettings[key as VehicleWheelsSetting];
			const defaultValue = defaultValues[key as VehicleWheelsSetting];

			if (value !== defaultValue) {
				price += wheelSetupPrice;
			}
		}
	}

	return price;
};
